module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/symbol-observable/index.js
 ** module id = 1350
 ** module chunks = 0
 **/